import React, { useEffect, useState } from "react";
import { Plus, X, Trash2, Edit3 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../../contexts/LanguageContext";
import { api } from "../../lib/api";

const empty = { name: "", role_tr: "", role_en: "", bio_tr: "", bio_en: "", photo_url: "", linkedin: "", instagram: "", order_num: 0 };

const TeamManager = () => {
  const { t } = useLang();
  const [members, setMembers] = useState([]);
  const [edit, setEdit] = useState(null);

  const load = async () => { const { data } = await api.get("/admin/team"); setMembers(data); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (edit.id) await api.put(`/admin/team/${edit.id}`, edit);
      else await api.post("/admin/team", edit);
      toast.success(t.admin.saved);
      setEdit(null);
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  };

  const remove = async (id) => {
    if (!window.confirm(t.admin.confirm)) return;
    await api.delete(`/admin/team/${id}`);
    toast.success(t.admin.deleted);
    load();
  };

  return (
    <div data-testid="admin-team">
      <div className="flex justify-between items-center" style={{ marginBottom: 24 }}>
        <h1 className="font-display" style={{ fontSize: "2.5rem", fontWeight: 300, color: "var(--warm-off-white)" }}>{t.admin.nav.team}</h1>
        <button data-testid="team-new" onClick={() => setEdit({ ...empty })} className="font-mono" style={{ padding: "10px 18px", background: "var(--bordeaux)", color: "var(--warm-off-white)", border: "none", fontSize: "0.7rem", letterSpacing: "0.18em", textTransform: "uppercase", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 8 }}><Plus size={14} /> {t.admin.new}</button>
      </div>
      <div className="grid" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 20 }}>
        {members.map((m) => (
          <div key={m.id} style={{ background: "var(--rich-black-light)", border: "1px solid rgba(139,32,53,0.25)" }}>
            <div style={{ aspectRatio: "3/4", overflow: "hidden" }}><img src={m.photo_url} alt={m.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} /></div>
            <div style={{ padding: 16 }}>
              <h3 style={{ color: "var(--warm-off-white)", fontWeight: 500 }}>{m.name}</h3>
              <p className="font-mono" style={{ fontSize: "0.7rem", letterSpacing: "0.15em", color: "var(--gold)", textTransform: "uppercase", marginTop: 4 }}>{m.role_tr}</p>
              <div className="flex" style={{ gap: 8, marginTop: 12 }}>
                <button onClick={() => setEdit({ ...m })} style={{ background: "transparent", border: "none", color: "var(--gold)", cursor: "pointer" }}><Edit3 size={14} /></button>
                <button onClick={() => remove(m.id)} style={{ background: "transparent", border: "none", color: "rgba(248,244,240,0.5)", cursor: "pointer" }}><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {edit && (
        <div onClick={() => setEdit(null)} style={{ position: "fixed", inset: 0, zIndex: 200, background: "rgba(10,10,10,0.92)", backdropFilter: "blur(10px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--rich-black-light)", border: "1px solid rgba(201,151,58,0.35)", maxWidth: 720, width: "100%", padding: 40, maxHeight: "90vh", overflowY: "auto", position: "relative" }}>
            <button onClick={() => setEdit(null)} style={{ position: "absolute", top: 16, right: 16, background: "transparent", border: "none", color: "var(--warm-off-white)" }}><X size={22} /></button>
            <h2 className="font-display" style={{ fontSize: "1.75rem", color: "var(--warm-off-white)", marginBottom: 24 }}>{edit.id ? t.admin.edit : t.admin.new}</h2>
            <div className="grid" style={{ gridTemplateColumns: "1fr 1fr", gap: 20 }}>
              <input placeholder="Name" className="input-line" value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} style={{ gridColumn: "1 / -1" }} />
              <input placeholder="Role TR" className="input-line" value={edit.role_tr} onChange={(e) => setEdit({ ...edit, role_tr: e.target.value })} />
              <input placeholder="Role EN" className="input-line" value={edit.role_en} onChange={(e) => setEdit({ ...edit, role_en: e.target.value })} />
              <textarea placeholder="Bio TR" rows={3} className="input-line" value={edit.bio_tr} onChange={(e) => setEdit({ ...edit, bio_tr: e.target.value })} />
              <textarea placeholder="Bio EN" rows={3} className="input-line" value={edit.bio_en} onChange={(e) => setEdit({ ...edit, bio_en: e.target.value })} />
              <input placeholder="Photo URL" className="input-line" value={edit.photo_url} onChange={(e) => setEdit({ ...edit, photo_url: e.target.value })} style={{ gridColumn: "1 / -1" }} />
              <input placeholder="LinkedIn URL" className="input-line" value={edit.linkedin} onChange={(e) => setEdit({ ...edit, linkedin: e.target.value })} />
              <input placeholder="Instagram URL" className="input-line" value={edit.instagram} onChange={(e) => setEdit({ ...edit, instagram: e.target.value })} />
              <input placeholder="Order" type="number" className="input-line" value={edit.order_num} onChange={(e) => setEdit({ ...edit, order_num: parseInt(e.target.value, 10) || 0 })} />
            </div>
            <button data-testid="team-save" onClick={save} className="font-mono" style={{ marginTop: 32, padding: "12px 28px", background: "var(--gold)", color: "var(--rich-black)", border: "none", fontSize: "0.7rem", letterSpacing: "0.2em", textTransform: "uppercase", cursor: "pointer" }}>{t.admin.save}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamManager;
